import {action, observable} from 'mobx'
import {observer} from 'mobx-react'
import React, {Component} from 'react'
import CheckLoginStatus from '../../conditions/CheckLoginStatus'
import AuthLayout from '../../layouts/AuthLayout'
import {ExternalSignUp} from "./ExternalSignup";
import Step4 from './Step4'

@observer
export default class SignUp extends Component {
  @observable step = 1

  @action
  openNext = () => {
    this.step++
  }

  @action
  reset = () => {
    this.step = 1
    window.location = '/'
  }

  render() {
    return (
      <CheckLoginStatus loggedInRedirect="/dashboard">
        <AuthLayout>
          {this.step === 1 && <ExternalSignUp onNext={this.openNext} onCancel={this.reset}/>}
          {/*{this.step === 2 && <Step2 onCancel={this.reset} onNext={this.openNext} />}*/}
          {/*{this.step === 3 && <Step3 onCancel={this.reset} onNext={this.openNext} />}*/}
          {this.step === 2 && <Step4 />}
        </AuthLayout>
      </CheckLoginStatus>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/SignUp/index.js